import {useWindowSize} from 'react-use';

export const useIsPortrait = () => {
  const {width, height} = useWindowSize();
  
  return height > width;
};

export default useIsPortrait;